import React, { Component } from 'react';
import TextField from '../TextField';
import CheckBox from '../CheckBox';
import Dropdown from '../Dropdown';
import DropdownMaster from '../DropdownMaster';
import FpgMinusIcon from '../../icons/fpgminusicon';
import FpgPlusIcon from '../../icons/fpgplusicon';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'
import { PAF_TYPES } from '../../cosntants'
import service from '../../services'
import SimpleReactValidator from 'simple-react-validator';
import Textarea from '../Textarea';
import Loader from '../loader';
import ConflictSaveModal from '../ConflictSaveModal';

let sub;

const mapStateToProps = state => ({
    PostAcceptanceEditListId: state.PostAcceptanceEditListId,
    recordConflict: state.recordConflict,
});

const mapDispatchToProps = dispatch => { return bindActionCreators(ActCreators, dispatch) };
class ProjectInternal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            projectUserId: this.props.PostAcceptanceEditListId,
            showConflictModal: false,
            mediaId: '',
            fileMakerId: '',
            title: '',
            pafType: '',
            article: '',
            category: '',
            filmProjectType: '',
            englishPhoneticProdununciation: '',
            studentScreening: { flag: 'Yes', note: 'Anything' },
            freeCommunityScreening: { flag: 'Yes', note: 'Anything' },
            historyOfFilm: '',
            adobeProductUse: '',
            aiTools: '',
            premiereFeature: '',
            stockFootage: '',
            cameras: [],
            cameraPurchaseOrRent: '',
            cameraAnamorphicOrSpecialLense: '',
            useCameraLence: [],
            influencedCamera: '',
            softwareUsedToEdit: '',
            softwareUsedToEditNote: '',
            influencedCameraNote: '',
            useAdobeProducts: '',
            useHardware: '',
            // useOtherTechnologyHardware: '',
            // realTimes3DTools: '',
            useStockFootage: '',
            fundingPlatform: '',
            sharingDistribution: '',
            hybridDistribution: '',
            useDropbox: '',
            brieflyExplain: '',
            cameraConfig: [
                { name: "Arri", desc: '', value: "ARRI", modal: ['Alexa', 'Alexa LF', 'Alexa Mini', 'Alexa 35', 'Alexa 65', 'Amira', 'Arriflex Film Camera', 'Other'] },
                { name: "Aaton", value: "AATON", modal: ['A-Minima', 'Delta', 'Penelope', 'Xtera', 'Other'], desc: '' },
                { name: "Black Magic", desc: '', value: "BLACKMAGIC", modal: ["Cinema Camera 6K", "Cinema Camera 6K G2", "URSA Cine 12K", "URSA Cine 17K", "PYXIS 6K", "PYXIS 12k", "URSA Mini Pro 12K", "URSA Mini Pro 4.6K", "URSA Cine Immersive", "Pocket Cinema Camera", "Micro Cinema Camera", "URSA Mini", "Other"] },
                { name: "Canon", desc: '', value: "CANON", modal: [ "C700 FF", "C700", "C500 Mark II", "C500", "C400", "C300 Mark III", "C300 Mark II", "C300", "C200", "C100", "C100 Mark II", "C50", "C70", "C80", "EOS R5 C", "ME20F-SH or ME200S-SH", "XA and XF Pro Camcorder Series", "ILC", "Other" ], },
                { name: "Gopro", desc: '', value: "GOPRO", modal: ['Hero', 'Other'] },
                { name: "Kinefinity", desc: '', value: "Kinefinity", modal: [ "MAVO Edge 8K", "MAVO Edge 6K", "MAVO S35 MKII", "MAVO LF MKII" ] },
                // { name: "No Camera", desc: '', value: "NO CAMERA", modal: ['Animation', 'Archival Footage'] },
                { name: "Panasonic", desc: '', value: "PANASONIC", modal: [ "EVA1", "GH5, GH5 II or GH5s", "GH6", "GH7", "S1 Series", "S1H", "S5 II Series", "S9", "VariCam Pure", "VariCam HS", "VariCam 35", "VariCam LT", "Other" ], },
                { name: "Panavision", desc: '', value: "PANAVISION", modal: ['Genesis', 'Millenium', 'Platinum', 'DXL', 'Other'] },
                { name: "Phantom", desc: '', value: "PHANTOM", modal: ['Gold', 'Flex', 'Miro ', 'Other'] },
                { name: "Red", desc: '', value: "RED", modal: [ "Raptor", "Komodo", "Komodo X", "Epic", "Dragon", "Monstro", "Raven", "Scarlet", "Weapon", "Other"] },
                { name: "Sony", desc: '', value: "SONY", modal: [ "LR1", "A7S Series", "A7R Series", "A7 Series", "A9 Series", "Alpha 1", "ZV Series", "FX30", "FX3", "XF6", "FX9", "F5", "F55", "F65", "FS5 Series", "FS7 Series", "FS700", "Venice", "Venice 2", "BURANO", "FR7", "Other" ], },
                // { name: "Specialty Brand", desc: '', value: "SPECIALTY BRAND", modal: ['Other'] },
                { name: "Other", desc: '', value: "OTHER", modal: ['Did not use a camera - Animation or Archival Footage','Specialty Brand'] }
            ],
            lensConfig: [
                { name: "7artisans", value: "7artisans", modal: ['Other'], desc: '' },
                { name: "Angenieux", value: "ANGENIEUX", modal: ['Optimo Anamorphic', 'Optimo', 'Type EZ', 'Other'], desc: '' },
                { name: "Arri/Zeiss", value: "ARRI/Zeiss", modal: ['Master Anamorphic', 'Master Primes', 'Ultra Primes', 'Compact Primes', 'Other'], desc: '' },
                { name: "Atlas Lens Co.", value: "ATLAS LENS CO.", modal: ['Orion Series', 'Mercury Series'], desc: '' },
                { name: "BLAZAR", value: "BLAZAR", modal: ['Other'], desc: '' },
                { name: "Canon", value: "CANON", modal: [ 'RF "Still" Series', 'EF "Still" Series', 'CN-R Cinema Series', 'CN-E Cinema Series', 'CINE-SERVO Series', 'COMPACT-SERVO Series', 'Flex Zoom Series', 'Sumire Prime Series', 'FD lenses', 'K35', 'Other' ], desc: '' },
                { name: "Cooke", value: "COOKE", modal: [ "5i", "Anamorphic", "Panchro Classic", "Mini S4i", "S4i", "S7i", "SP3", "Varotal", "Other" ], desc: '' },
                { name: "DZOFilm", value: "DZOFilm", modal: ['Other'], desc: '' },
                { name: "Fujinon", value: "FUJINON", modal: ['MK series', 'Premista Series', 'Cabrio Series','Premier series', 'Other'], desc: '' },
                { name: "Hawk", value: "HAWK", modal: ['V-Lite Series', 'V-Series', 'Other'], desc: '' },
                { name: "IRIX", value: "IRIX", modal: ['Other'], desc: '' },
                { name: "Kowa", value: "KOWA", modal: ['Anamorphics', 'Spherical Primes', 'Other'], desc: '' },
                { name: "Leica", value: "LEICA", modal: ['Other'], desc: '' },
                { name: "LEITZ", value: "LEITZ", modal: ['Other'], desc: '' },
                { name: "MEIKE", value: "MEIKE", modal: ['Other'], desc: '' },
                { name: "MITAKON Zhongyi", value: "MITAKON Zhongyi", modal: ['Other'], desc: '' },
                { name: "NiSi", value: "NiSi", modal: ['Other'], desc: '' },
                { name: "Panasonic", value: "PANASONIC", modal: ['Other'], desc: '' },
                { name: "Panavision", value: "PANAVISION", modal: ['Anamorphic', 'Primo', 'Super Panavision 70 ', 'Other'], desc: '' },
                { name: "Rokinon", value: "ROKINON", modal: ['XEEN series', 'Other'], desc: '' },
                { name: "SAMYANG", value: "SAMYANG", modal: ['Other'], desc: '' },
                { name: "SCHNEIDER", value: "SCHNEIDER", modal: ['Other'], desc: '' },
                { name: "Sigma", value: "SIGMA", modal: ['Classic Art', 'High speed', 'High speed Art', 'Other'], desc: '' },
                { name: "Sirui", value: "Sirui", modal: ['Other'], desc: '' },
                { name: "SLR MAGIC", value: "SLR MAGIC", modal: ['Other'], desc: '' },
                { name: "Sony", value: "SONY", modal: ['CineAlta', 'Other'], desc: '' },
                { name: "Tamron", value: "TAMRON", modal: ['Other'], desc: '' },
                { name: "TOKINA", value: "TOKINA", modal: ['Cinema', 'Cinema ATX', 'Cinema Vista series', 'Other'], desc: '' },
                { name: "VENUS OPTICS", value: "VENUS OPTICS", modal: ['Other'], desc: '' },
                { name: "VILTROX", value: "VILTROX", modal: ['Other'], desc: '' },
                { name: "Zeiss", value: "ZEISS", modal: ['Master Anamorphic', 'Master Primes', 'Supreme series', 'Photo Lenses', 'Ultra Primes', 'Other'], desc: '' },
                { name: "Other", value: "OTHER", modal: ['Other'], desc: '' }
            ],
            adobeProductUse: [
                { id: "1", name: "none", label: "None", value: false },
                { id: "2", name: "premierePro", label: "Premiere Pro", value: false },
                { id: "3", name: "productionsInPremierePro", label: "Productions in Premiere Pro", value: false },
                { id: "4", name: "speechToTextInPremierePro", label: "Speech to Text in Premiere Pro", value: false },
                { id: "5", name: "adobeFirefly", label: "Adobe Firefly", value: false },
                { id: "7", name: "afterEffects", label: "After Effects", value: false },
                { id: "8", name: "frameIo", label: "Frame.io", value: false },
                { id: "9", name: "cameraToCloud", label: "Camera to Cloud", value: false },
                { id: "10", name: "audition", label: "Audition", value: false },
                { id: "11", name: "photoshop", label: "Photoshop", value: false },
                { id: "12", name: "illustrator", label: "Illustrator", value: false },
                { id: "13", name: "adobeMediaEncoder", label: "Adobe Media Encoder", value: false },
                { id: "14", name: "substance3D", label: "Substance 3D", value: false },
                { id: "15", name: "other", label: "Other", value: false },
            ],
            premiereFeature:[
                { id:"1", name: "textBasedEditing", label: "Text-Based Editing", value:false },
                { id:"2", name: "productionsInPremierePro", label: "Productions in Premiere Pro", value:false },
                { id:"3", name: "mediaIntelligenceSearchPanel", label: "Media Intelligence and Search panel", value:false },
                { id:"4", name: "generativeExtend", label: "Generative Extend", value:false },
                { id:"5", name: "enhanceSpeech", label: "Enhance Speech", value:false },
                { id:"6", name: "captionTranslation", label: "Caption Translation", value:false },
                { id:"7", name: "colorManagement", label: "Color Management", value:false },
            ],
            aiTools: [
                { id:"1", name: "no_ai_used", label: "No, we did not use AI at any stage", value:false },
                { id:"2", name: "ideation_concept", label: "Ideation or concept development (e.g., brainstorming, pitching)", value:false },
                { id:"3", name: "pre_production", label: "Pre-production (e.g., storyboarding or previsualization)", value:false },
                { id:"4", name: "production", label: "Production (e.g., virtual production environments, camera automation)", value:false },
                { id:"5", name: "post_production", label: "Post-production (e.g., assembly, creating temporary placeholders)", value:false },
                { id:"6", name: "visual_effects_animation", label: "Visual effects or animation", value:false },
                { id:"7", name: "sound_design_music", label: "Sound design or music (e.g., generated sound effects, cleanup)", value:false },
                { id:"8", name: "marketing_promotional", label: "Marketing or promotional materials", value:false },
                { id:"9", name: "other", label: "Other", value:false }
            ],
            fireflyModules: [
                { id: "1", name: "fireflyBoards", label: "Firefly Boards", value: false },
                { id: "2", name: "imageVideoGeneration", label: "Image and video generation in Firefly", value: false },
                { id: "3", name: "audioGeneration", label: "Audio generation in Firefly", value: false },
                { id: "4", name: "fireflyAiAssistant", label: "Firefly AI Assistant", value: false },
            ],
            stockFootage: [
                { id: "ado", name: "adobeStock", label: "Adobe Stock", value: false },
                { id: "shi", name: "shitterstock", label: "Shutterstock", value: false },
                { id: "pon", name: "pond5", label: "Pond5", value: false },
                { id: "get", name: "getty", label: "Getty", value: false },
                { id: "dis", name: "dissolve", label: "Dissolve", value: false },
                // { id: "no", name: "noUseAnyStock", label: "I did not use any stock footage.", value: false },
                { id: "opth", name: "other", label: "Other", value: false },
            ],
            realTimes3DTools :[
                { id:"notUseRealTimes3D", name: "notUseRealTimes3D", label: "I did not use a 3D real-time engine", value:false },
                { id:"Unity", name: "Unity", label: "Unity", value: false},
                { id:"Unreal", name: "Unreal", label: "Unreal", value: false},
                { id:"AdobeAero", name: "AdobeAero", label: "Adobe Aero", value: false },
                { id:"InHouse", name: "InHouse", label: "In-House/Proprietary", value: false},
                // { id:"6", name: "noUseAnyStock", label: "I did not use any stock footage", value: false },
                { id:"other",name: "other", label: "Other", value: false },
            ],
            useOtherTechnologyHardware:[
                { id: "storageDevices",name: "storageDevices", label: "Storage Devices/Hard Drives", value: false },
                { id: "desktopLaptop", name: "desktopLaptop", label: "Laptop/Desktop Computer", value: false },
                { id: "audioSoftware", name: "audioSoftware", label: "Audio Software/Hardware(pre/post)", value: false },
                { id: "soundMixingSoftware",name: "soundMixingSoftware", label: "Sound Mixing Software", value: false },
                { id: "graphicsSoftware", name: "graphicsSoftware", label: "Graphics Software", value: false },
                { id: "mobilePhoneTechnology",name: "mobilePhoneTechnology", label: "Mobile Phone Technology", value: false },
                { id: "gameEngine", name: "gameEngine", label: "Game Engine", value: false },
                { id: "vrArHeadset",name: "vrArHeadset", label: "VR/AR Headset", value: false },
                { id: "None",name: "None", label: "None", value: false },
            ],
            options: {
                'cameraPurchaseOrRent': ['Purchase', 'Rent', 'N/A'],
                'cameraAnamorphicOrSpecialLense': ['Anamorphic', 'Spherical', 'Both', 'N/A'],
                'influencedCamera': ['Format', 'Features', 'Brand Reputation', 'Recommendations from Colleagues or Friends', 'Price', 'Familiarity with Brand', 'Availability at Rental House', 'Rental House Staff', 'Size/Weight', 'Other'],
                'softwareUsedToEdit': ['Avid Media Composer', 'Adobe Premiere', 'Final Cut Pro - earlier version','Final Cut Pro X', 'DaVinci Resolve', 'Other'],
                'useAdobeProducts': ['Yes', "No, we didn't use any Adobe products"],
                'useHardware': ['PC- Dell', 'PC- HP', 'Mac- Apple', 'Other'],
                'useOtherTechnologyHardware': ['Storage Devices/Hard Drives', ' Laptop/Desktop Computer', 'Audio Software/Hardware(pre/post)', 'Sound Mixing Software', 'Graphics Software', 'Mobile Phone Technology', 'Game Engine', 'VR/AR Headset', 'None'],
                // 'realTimes3DTools': ['I did not use a 3D real-time engine', 'Unity', 'Unreal', 'Adobe Aero', ' In-House/proprietary', 'Other'],
                'fundingPlatform': ['Kickstarter', 'Indie-gogo', 'Slated', 'Rally', 'Crowdfunder', 'RocketHub', 'Other', 'None']
            },
            allSelected:false,
            allPremiereFeatureSelected:false,
            allAiToolsSelected:false,
            allSelected1:false,
            allSelected2:false,
            loading: false,
            AllDropData: [],
            previwId:'',
            isProjectInternalEdited: false,
        }
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();
    }

    markProjectInternalEdited = () => {
        if (!this.state.isProjectInternalEdited) {
            this.setState({ isProjectInternalEdited: true });
        }
    }

    updateState = (state, callback) => {
        this.setState(state, () => {
            this.markProjectInternalEdited();
            if (callback) callback();
        });
    }

    componentWillUnmount = () => {
        if(sub) {
            sub.unsubscribe();
        }
    }

    componentDidMount() {
        this.apiserve.sendevent("paf|project|getDetail", {});
        if (this.state.projectUserId) this.apiserve.sendevent("paf|project|getProjectInfo", { id: this.state.projectUserId });
        this.getAllDetails();
    };

    // componentWillUnmount = () => {
    //     this.submitThirdForm()
    //     sub.unsubscribe();
       
    // }
    cancelFn = () => {

        this.props.history.push('/paf-projectlist');

    }
    getAllDetails() {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "paf|project|getProjectInfo":
                    if (!response.error) {
                        var ContactInfo = JSON.parse(JSON.stringify(response.data));
                        this.setState({
                            userdata: ContactInfo,
                            isProjectInternalEdited: false,
                            mediaId: ContactInfo.mediaId ? ContactInfo.mediaId : '',
                            fileMakerId: ContactInfo.fileMakerId ? ContactInfo.fileMakerId : '', 
                            userInfo: {
                                title: ContactInfo.title,
                                pafType: ContactInfo.pafType,
                                article: ContactInfo.article,
                                category: ContactInfo.category,
                                filmProjectType: ContactInfo.filmProjectType,
                                englishPhoneticProdununciation: ContactInfo.englishPhoneticProdununciation,
                                studentScreening: ContactInfo.studentScreening,
                                freeCommunityScreening: ContactInfo.freeCommunityScreening,
                                historyOfFilm: ContactInfo.historyOfFilm,
                                adobeProductUse: ContactInfo.adobeProductUse,
                                premiereFeature: ContactInfo.premiereFeature,
                                aiTools: {
                                    ...ContactInfo.aiTools,
                                    ideation_concept_tool: ContactInfo.aiTools?.ideation_concept_tool || '',
                                    pre_production_tool: ContactInfo.aiTools?.pre_production_tool || '',
                                    production_tool: ContactInfo.aiTools?.production_tool || '',
                                    post_production_tool: ContactInfo.aiTools?.post_production_tool || '',
                                    visual_effects_animation_tool: ContactInfo.aiTools?.visual_effects_animation_tool || '',
                                    sound_design_music_tool: ContactInfo.aiTools?.sound_design_music_tool || '',
                                    marketing_promotional_tool: ContactInfo.aiTools?.marketing_promotional_tool || '',
                                },
                                fireflyModules: ContactInfo.fireflyModules,
                                stockFootage: ContactInfo.stockFootage,
                                cameras: ContactInfo.cameras.length > 0 ? ContactInfo.cameras : [{ brand: '', model: '', desc: '', _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString() }],
                                cameraPurchaseOrRent: ContactInfo.cameraPurchaseOrRent,
                                cameraAnamorphicOrSpecialLense: ContactInfo.cameraAnamorphicOrSpecialLense,
                                useCameraLence: ContactInfo.useCameraLence.length > 0 ? ContactInfo.useCameraLence : [{ brand: '', model: '', desc: '', _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString() }], 
                                influencedCamera: ContactInfo.influencedCamera,
                                softwareUsedToEdit: ContactInfo.softwareUsedToEdit,
                                softwareUsedToEditNote: ContactInfo.softwareUsedToEditNote,
                                influencedCameraNote: ContactInfo.influencedCameraNote,
                                useAdobeProducts: ContactInfo.useAdobeProducts,
                                useHardware: ContactInfo.useHardware,
                                useOtherTechnologyHardware: ContactInfo.useOtherTechnologyHardware,
                                realTimes3DTools: ContactInfo.realTimes3DTools,
                                useOtherTechnologyHardware: ContactInfo.useOtherTechnologyHardware,
                                useStockFootage: ContactInfo.useStockFootage,
                                fundingPlatform: ContactInfo.fundingPlatform,
                                sharingDistribution: ContactInfo.sharingDistribution,
                                hybridDistribution: ContactInfo.hybridDistribution,
                                useDropbox: ContactInfo.useDropbox,
                                brieflyExplain: ContactInfo.brieflyExplain,
                                fileMakerId:ContactInfo.fileMakerId,
                                credits: ContactInfo.credits,
                                mainPublicityContacts: ContactInfo.mainPublicityContacts,
                                mainContacts: ContactInfo.mainContacts,
                                techContact: ContactInfo.techContact,
                                filmProjectType: ContactInfo.filmProjectType,
                                englishPhoneticProdununciation: ContactInfo.englishPhoneticProdununciation,
                                composer:ContactInfo.composer,
                                distributor:ContactInfo.distributor,
                                editor:ContactInfo.editor,
                                salesAgent:ContactInfo.salesAgent.length > 0 ? ContactInfo.salesAgent : [{
                                    address1: "",
                                    address2: "",
                                    city: "",
                                    company: "",
                                    country: "",
                                    email: "",
                                    firstName: "",
                                    lastName: "",
                                    middleName: "",
                                    distributionType:"",
                                    phoneNumber: "",
                                    state: "",
                                    title: "",
                                    type: "",
                                    zipCode: "",
                                    _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
                                }],
                                cinematographer:ContactInfo.cinematographer,
                                projectInfo: {
                                    soundFormat: response.data.projectInfo.soundFormat,
                                    premiereStatus: response.data.projectInfo.premiereStatus,
                                    yearFinished: response.data.projectInfo.yearFinished,
                                    inPersonFormat: response.data.projectInfo.inPersonFormat,
                                    onlineFormat: response.data.projectInfo.onlineFormat,
                                    aspectRatio: response.data.projectInfo.aspectRatio,
                                    color: response.data.projectInfo.color,
                                    language: response.data.projectInfo.language,
                                    subtitles: response.data.projectInfo.subtitles,
                                    finalRunTime: response.data.projectInfo.finalRunTime,
                                    runTime: response.data.projectInfo.runTime,
                                    includeStroboscopicImg: response.data.projectInfo.includeStroboscopicImg,
                                    timecodeOccursInProject: response.data.projectInfo.timecodeOccursInProject,
                                    captionAudioInDCP: response.data.projectInfo.captionAudioInDCP,

                                },
                                digitalMedia: {
                                    officialWebsite: response.data.digitalMedia.officialWebsite,
                                    youtubeOrVimeoTrailer: response.data.digitalMedia.youtubeOrVimeoTrailer,
                                    instagram: response.data.digitalMedia.instagram,
                                    facebook: response.data.digitalMedia.facebook,
                                    twitter: response.data.digitalMedia.twitter,
                                    hastag: response.data.digitalMedia.hastag,
                                },
                                publicContact: {
                                    firstName: response.data.publicContact.firstName,
                                    middleName: response.data.publicContact.middleName,
                                    lastName: response.data.publicContact.lastName,
                                    company: response.data.publicContact.company,
                                    publicEmail: response.data.publicContact.publicEmail,
                                    website: response.data.publicContact.website,
                                    phoneNumber: response.data.publicContact.phoneNumber,
                                    type: response.data.publicContact.type,
                                },
                                postFestivalContact: {
                                    firstName: response.data.postFestivalContact.firstName,
                                    middleName: response.data.postFestivalContact.middleName,
                                    lastName: response.data.postFestivalContact.lastName,
                                    company: response.data.postFestivalContact.company,
                                    publicEmail: response.data.postFestivalContact.publicEmail,
                                    website: response.data.postFestivalContact.website,
                                    phoneNumber: response.data.postFestivalContact.phoneNumber,
                                    type: response.data.postFestivalContact.type,
                                },
                                countryOfOrigin: ContactInfo.countryOfOrigin,
                                category: ContactInfo.category,
                                filmCategoryData: ContactInfo.filmCategoryData,
                                synopsis: ContactInfo.synopsis,
                                images: ContactInfo.images.length === 0 ? [{ _id: Math.random().toString(), link: "", inSite: "" }, { _id: Math.random().toString(), link: "", inSite: "" }, { _id: Math.random().toString(), link: "", inSite: "" }] : ContactInfo.images,
                            },
                            adobeProductUse: [
                                { id: "1", name: "none", label: "None", value: ContactInfo.adobeProductUse.none === undefined ? false : ContactInfo.adobeProductUse.none },
                                { id: "2", name: "premierePro", label: "Premiere Pro", value: ContactInfo.adobeProductUse.premierePro === undefined ? false : ContactInfo.adobeProductUse.premierePro },
                                { id: "3", name: "productionsInPremierePro", label: "Productions in Premiere Pro", value: ContactInfo.adobeProductUse.productionsInPremierePro === undefined ? false : ContactInfo.adobeProductUse.productionsInPremierePro },
                                { id: "4", name: "speechToTextInPremierePro", label: "Speech to Text in Premiere Pro", value: ContactInfo.adobeProductUse.speechToTextInPremierePro === undefined ? false : ContactInfo.adobeProductUse.speechToTextInPremierePro },
                                { id: "5", name: "adobeFirefly", label: "Adobe Firefly", value: ContactInfo.adobeProductUse.adobeFirefly === undefined ? false : ContactInfo.adobeProductUse.adobeFirefly },
                                { id: "7", name: "afterEffects", label: "After Effects", value: ContactInfo.adobeProductUse.afterEffects === undefined ? false : ContactInfo.adobeProductUse.afterEffects },
                                { id: "8", name: "frameIo", label: "Frame.io", value: ContactInfo.adobeProductUse.frameIo === undefined ? false : ContactInfo.adobeProductUse.frameIo },
                                { id: "9", name: "cameraToCloud", label: "Camera to Cloud", value: ContactInfo.adobeProductUse.cameraToCloud === undefined ? false : ContactInfo.adobeProductUse.cameraToCloud },
                                { id: "10", name: "audition", label: "Audition", value: ContactInfo.adobeProductUse.audition === undefined ? false : ContactInfo.adobeProductUse.audition },
                                { id: "11", name: "photoshop", label: "Photoshop", value: ContactInfo.adobeProductUse.photoshop === undefined ? false : ContactInfo.adobeProductUse.photoshop },
                                { id: "12", name: "illustrator", label: "Illustrator", value: ContactInfo.adobeProductUse.illustrator === undefined ? false : ContactInfo.adobeProductUse.illustrator },
                                { id: "13", name: "adobeMediaEncoder", label: "Adobe Media Encoder", value: ContactInfo.adobeProductUse.adobeMediaEncoder === undefined ? false : ContactInfo.adobeProductUse.adobeMediaEncoder },
                                { id: "14", name: "substance3D", label: "Substance 3D", value: ContactInfo.adobeProductUse.substance3D === undefined ? false : ContactInfo.adobeProductUse.substance3D },
                                { id: "15", name: "other", label: "Other", value: ContactInfo.adobeProductUse.other === undefined ? false : ContactInfo.adobeProductUse.other },
                            ],
                            premiereFeature: [
                                { id: "1", name: "textBasedEditing", label: "Text-Based Editing", value: ContactInfo.premiereFeature.textBasedEditing === undefined ? false : ContactInfo.premiereFeature.textBasedEditing },
                                { id: "2", name: "productionsInPremierePro", label: "Productions in Premiere Pro", value: ContactInfo.premiereFeature.productionsInPremierePro === undefined ? false : ContactInfo.premiereFeature.productionsInPremierePro },
                                { id: "3", name: "mediaIntelligenceSearchPanel", label: "Media Intelligence and Search panel", value: ContactInfo.premiereFeature.mediaIntelligenceSearchPanel === undefined ? false : ContactInfo.premiereFeature.mediaIntelligenceSearchPanel },
                                { id: "4", name: "generativeExtend", label: "Generative Extend", value: ContactInfo.premiereFeature.generativeExtend === undefined ? false : ContactInfo.premiereFeature.generativeExtend },
                                { id: "5", name: "enhanceSpeech", label: "Enhance Speech", value: ContactInfo.premiereFeature.enhanceSpeech === undefined ? false : ContactInfo.premiereFeature.enhanceSpeech },
                                { id: "6", name: "captionTranslation", label: "Caption Translation", value: ContactInfo.premiereFeature.captionTranslation === undefined ? false : ContactInfo.premiereFeature.captionTranslation },
                                { id: "7", name: "colorManagement", label: "Color Management", value: ContactInfo.premiereFeature.colorManagement === undefined ? false : ContactInfo.premiereFeature.colorManagement },
                            ],
                            aiTools: [
                                { id: "1", name: "no_ai_used", label: "No, we did not use AI at any stage", value: ContactInfo.aiTools.no_ai_used === undefined ? false : ContactInfo.aiTools.no_ai_used },
                                { id: "2", name: "ideation_concept", label: "Ideation or concept development (e.g., brainstorming, pitching)", value: ContactInfo.aiTools.ideation_concept === undefined ? false : ContactInfo.aiTools.ideation_concept },
                                { id: "3", name: "pre_production", label: "Pre-production (e.g., storyboarding or previsualization)", value: ContactInfo.aiTools.pre_production === undefined ? false : ContactInfo.aiTools.pre_production },
                                { id: "4", name: "production", label: "Production (e.g., virtual production environments, camera automation)", value: ContactInfo.aiTools.production === undefined ? false : ContactInfo.aiTools.production },
                                { id: "5", name: "post_production", label: "Post-production (e.g., assembly, creating temporary placeholders)", value: ContactInfo.aiTools.post_production === undefined ? false : ContactInfo.aiTools.post_production },
                                { id: "6", name: "visual_effects_animation", label: "Visual effects or animation", value: ContactInfo.aiTools.visual_effects_animation === undefined ? false : ContactInfo.aiTools.visual_effects_animation },
                                { id: "7", name: "sound_design_music", label: "Sound design or music (e.g., generated sound effects, cleanup)", value: ContactInfo.aiTools.sound_design_music === undefined ? false : ContactInfo.aiTools.sound_design_music },
                                { id: "8", name: "marketing_promotional", label: "Marketing or promotional materials", value: ContactInfo.aiTools.marketing_promotional === undefined ? false : ContactInfo.aiTools.marketing_promotional },
                                { id: "9", name: "other", label: "Other", value: ContactInfo.aiTools.other === undefined ? false : ContactInfo.aiTools.other }
                            ],
                            fireflyModules: [
                                { id: "1", name: "fireflyBoards", label: "Firefly Boards", value: ContactInfo.fireflyModules?.fireflyBoards === undefined ? false : ContactInfo.fireflyModules?.fireflyBoards },
                                { id: "2", name: "imageVideoGeneration", label: "Image and video generation in Firefly", value: ContactInfo.fireflyModules?.imageVideoGeneration === undefined ? false : ContactInfo.fireflyModules?.imageVideoGeneration },
                                { id: "3", name: "audioGeneration", label: "Audio generation in Firefly", value: ContactInfo.fireflyModules?.audioGeneration === undefined ? false : ContactInfo.fireflyModules?.audioGeneration },
                                { id: "4", name: "fireflyAiAssistant", label: "Firefly AI Assistant", value: ContactInfo.fireflyModules?.fireflyAiAssistant === undefined ? false : ContactInfo.fireflyModules?.fireflyAiAssistant },
                            ],
                            stockFootage: [
                                { id: "ado", name: "adobeStock", label: "Adobe Stock", value: ContactInfo.stockFootage.adobeStock === undefined ? false : ContactInfo.stockFootage.adobeStock },
                                { id: "shi", name: "shitterstock", label: "Shutterstock", value: ContactInfo.stockFootage.shitterstock === undefined ? false : ContactInfo.stockFootage.shitterstock },
                                { id: "pon", name: "pond5", label: "Pond5", value: ContactInfo.stockFootage.pond5 === undefined ? false : ContactInfo.stockFootage.pond5 },
                                { id: "get", name: "getty", label: "Getty", value: ContactInfo.stockFootage.getty === undefined ? false : ContactInfo.stockFootage.getty },
                                { id: "dis", name: "dissolve", label: "Dissolve", value: ContactInfo.stockFootage.dissolve === undefined ? false : ContactInfo.stockFootage.dissolve },
                                // { id: "no", name: "noUseAnyStock", label: "I did not use any stock footage.", value: ContactInfo.stockFootage.none === undefined ? false : ContactInfo.stockFootage.none },
                                { id: "opth", name: "other", label: "Other", value: ContactInfo.stockFootage.other === undefined ? false : ContactInfo.stockFootage.other },
                            ],
                            realTimes3DTools :[
                                { id:"notUseRealTimes3D", name: "notUseRealTimes3D", label: "I did not use a 3D real-time engine", value:ContactInfo.realTimes3DTools.notUseRealTimes3D === undefined ? false : ContactInfo.realTimes3DTools.notUseRealTimes3D },
                                { id:"Unity", name: "Unity", label: "Unity", value: ContactInfo.realTimes3DTools.Unity === undefined ? false : ContactInfo.realTimes3DTools.Unity},
                                { id:"Unreal", name: "Unreal", label: "Unreal", value: ContactInfo.realTimes3DTools.Unreal === undefined ? false : ContactInfo.realTimes3DTools.Unreal},
                                { id:"AdobeAero", name: "AdobeAero", label: "Adobe Aero", value: ContactInfo.realTimes3DTools.AdobeAero === undefined ? false : ContactInfo.realTimes3DTools.AdobeAero },
                                { id:"InHouse", name: "InHouse", label: "In-House/Proprietary", value: ContactInfo.realTimes3DTools.InHouse === undefined ? false : ContactInfo.realTimes3DTools.InHouse},
                                // { id:"6", name: "noUseAnyStock", label: "I did not use any stock footage", value: ContactInfo.realTimes3DTools.other === undefined ? false : ContactInfo.realTimes3DTools.other },
                                { id:"other",name: "other", label: "Other", value: ContactInfo.realTimes3DTools.other === undefined ? false : ContactInfo.realTimes3DTools.other },
                            ],
                        })
                    } else {
                        this.setState({ errorPopup: true, errorMsg: response.data.error ? response.data.error : response.data })
                    }
                    break;

                case "paf|project|getDetail":
                    if (!response.error) {
                        this.setState({ AllDropData: response.data })
                    }
                    else this.apiserve.error(response.data.error)
                    break;
                case "paf|project|updateThirdPage":
                         this.setState({ loading: false, isProjectInternalEdited: false })
                       if (!response.error) {
                            this.apiserve.success('Updated successfully.!')
                            return;
                       }
                       else this.apiserve.error(response.data.error)
                       break;
                    case "tempStorage|create":
                    if (!response.error) {
                        this.setState({
                            previwId:response?.data?._id,
                            loading: false
                        })
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_PAF + `Preview/paf-preview?data=${response?.data?._id}`);
                    }
                    else this.apiserve.error(response.data.error)
                    break;

                default:
                    break;
            }
        });
    };

    getCameraDetails = (label,label2) => {

        const { userInfo } = this.state;
        var cameras = this.state.cameraConfig.map(_ => _.value);

        return (
            <div className="ps_prod_que">
                <div className="disp_flex">
                    <div className="ps_prod_que_label field_row">
                        <label>{label}</label>
                        {label2 && <label>{label2}</label>}
                    </div>
                    <div className="ps_action field_row">
                        {
                            userInfo?.cameras?.length > 0 && userInfo.cameras.map((cam, i) => (
                                <div className="d_flex d_flex_align_center">
                                    <Dropdown label="BRAND" name='brand' value={cam.brand} options={cameras} onChange={(e) => this.handleCamera_LenseChange(e, cam, 'cameras')} DefaultOption={'Select From Below'} />
                                    <Dropdown label="MODEL" name='model' value={cam.model} options={this.state.cameraConfig.find(_ => _.value === cam.brand)?.modal} onChange={(e) => this.handleCamera_LenseChange(e, cam, 'cameras')} DefaultOption={'Select From Below'} />
                                    {cam.model === 'Other' && <TextField label="OTHER MODEL NAME" name='desc' value={cam.desc} onChange={(e) => this.handleCamera_LenseChange(e, cam, 'cameras')} />}
                                    {cam.model === 'DLSR' && <TextField label="OTHER MODEL NAME" name='desc' value={cam.desc} onChange={(e) => this.handleCamera_LenseChange(e, cam, 'cameras')} />}
                                    {cam.model === 'Specialty Brand' && <TextField label="OTHER MODEL NAME" name='desc' value={cam.desc} onChange={(e) => this.handleCamera_LenseChange(e, cam, 'cameras')} />}
                                    <div className="ps_add_remove">
                                        <span className="pointer" style={{ cursor: userInfo.cameras.length < 2 ? 'pointer' : 'not-allowed' }} onClick={(e) => userInfo.cameras.length < 2 ? this.addCamera('cameras') : ''}> <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /> </span>
                                        {i !== 0 && <span className="pointer mr_5" onClick={(e) => this.removeCamera(e, cam, 'cameras')}> <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /> </span>}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        )
    };

    getLenseDetails = (label,label2) => {
        const { userInfo } = this.state;
        var lense = this.state.lensConfig.map(_ => _.value);
        return (
            <div className="ps_prod_que">
                <div className="disp_flex">
                    <div className="ps_prod_que_label field_row">
                        <label>{label}</label>
                       { label2 && <label>{label2}</label>}
                    </div>
                    <div className="ps_action field_row">
                        {
                            userInfo?.useCameraLence?.length > 0 && userInfo.useCameraLence.map((len, i) => (
                                <div className="d_flex d_flex_align_center">
                                    <Dropdown label="BRAND" name='brand' value={len.brand} options={lense} onChange={(e) => this.handleCamera_LenseChange(e, len, 'useCameraLence')} DefaultOption={'Select From Below'} />
                                    <Dropdown label="MODEL" name='model' value={len.model} options={this.state.lensConfig.find(_ => _.value === len.brand)?.modal} onChange={(e) => this.handleCamera_LenseChange(e, len, 'useCameraLence')} DefaultOption={'Select From Below'} />
                                    {len.model === 'Other' && <TextField label="OTHER MODEL NAME" name='desc' value={len.desc} onChange={(e) => this.handleCamera_LenseChange(e, len, 'useCameraLence')} />}
                                    <div className="ps_add_remove">
                                        <span className="pointer" style={{ cursor: userInfo.useCameraLence.length < 2 ? 'pointer' : 'not-allowed' }} onClick={(e) => userInfo.useCameraLence.length < 2 ? this.addCamera('useCameraLence') : ''}> <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /> </span>
                                        {i !== 0 && <span className="pointer mr_5" onClick={(e) => this.removeCamera(e, len, 'useCameraLence')}> <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /> </span>}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        )
    };

    removeCamera = (e, cam, TYPE) => {
        this.updateState({
            userInfo: {
                ...this.state.userInfo,
                [TYPE]: this.state.userInfo[TYPE].filter(_ => _._id !== cam._id)
            }
        });
    };

    addCamera = (TYPE) => {

        let oldData = JSON.parse(JSON.stringify(this.state.userInfo[TYPE]))

        oldData.push({ desc: "", _id: Math.random(), brand: "", model: "" })

        this.updateState({
            userInfo: {
                ...this.state.userInfo,
                [TYPE]: oldData
            }
        });
    };

    handleCamera_LenseChange = (e, cam, TYPE) => {

        const { name, value } = e.target;

        this.state.userInfo[TYPE].forEach(CAM => {
            if (CAM._id === cam._id)

                CAM[name] = value

        })
        this.updateState({})
    };

    getTextAreaWithSelect = (label, note, mainKey, flagName, noteName, flagValue, nameValue, dropdown = false) => {
        return (
            <div className="field_row pb_10">
                <div className="field_row_inner">
                    <div className="disp_flex d_flex_align_center ps_que_wrap mb_10">
                        <div className="ps_que_label">
                            <label>{label}</label>
                            {note && <label>{note}</label>}
                        </div>
                        {dropdown ? 
                        <Dropdown value={flagValue} name={flagName} onChange={(e) => this.handleChange(e, mainKey)} options={["Yes", "No"]} DefaultOption={'Select From Below'} /> : ''}
                    </div>
                    <div className="field_input relative">
                        <textarea value={nameValue} name={noteName} onChange={(e) => this.handleChange(e, mainKey)} rows="8"> </textarea>
                    </div>
                </div>
            </div>
        )
    };

    getSingleDropdown = (label, options, keyValue) => {
        const { userInfo } = this.state;
        return (
            <div className="ps_prod_que">
                <div className="disp_flex">
                    <div className="ps_prod_que_label field_row">
                        <label>{label}</label>
                    </div>
                    <div className="ps_action field_row">
                        <div className="d_flex d_flex_align_center">
                            <Dropdown name={keyValue} value={userInfo && userInfo[keyValue] && userInfo[keyValue]} options={options} onChange={(e) => this.handleChangeSingleDrop(e, keyValue)} DefaultOption={'Select From Below'} />
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    handleChangeSingleDrop = (e, mainKey) => {
        const { value } = e.target;
        this.updateState({
            userInfo: {
                ...this.state.userInfo,
                [mainKey]: value
            }
        })
    };

    handleProductChange = (e, mainKey) => {
        const { name, checked } = e.target;
        if(name === 'none' && checked && mainKey === 'adobeProductUse'){
            this.updateState({
                userInfo:{
                    ...this.state.userInfo,
                    [mainKey]:{
                        adobeMediaEncoder: false,
                        afterEffects: false,
                        anywhere: false,
                        audition: false,
                        cameraToCloud: false,
                        encore: false,
                        frameIo: false,
                        illustrator: false,
                        none: checked,
                        other: false,
                        photoshop: false,
                        prelude: false,
                        premierePro: false,
                        productionsInPremierePro: false,
                        speechToTextInPremierePro: false,
                        speedGrade: false,
                        story: false,
                        substance3D: false,
                    }
                }
            })
        } else if(name === 'no_ai_used' && checked && mainKey === 'aiTools'){
            this.updateState({
                userInfo:{
                    ...this.state.userInfo,
                    aiTools:{
                        no_ai_used: true,
                        ideation_concept: false,
                        pre_production: false,
                        production: false,
                        post_production: false,
                        visual_effects_animation: false,
                        sound_design_music: false,
                        marketing_promotional: false,
                        other: false,
                        otherDesc: '',
                        ideation_concept_tool: '',
                        pre_production_tool: '',
                        production_tool: '',
                        post_production_tool: '',
                        visual_effects_animation_tool: '',
                        sound_design_music_tool: '',
                        marketing_promotional_tool: '',
                    }
                }
            })
        } else {
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    [mainKey]: {
                        ...this.state.userInfo[mainKey],
                        [name]: checked,
                        none: false,
                        ...(mainKey === 'aiTools' ? { no_ai_used: false } : {})
                    }
                }
            })
        }
        if(mainKey === 'adobeProductUse'){
            this.state.adobeProductUse.forEach((check) => {
                if (check.name === e.target.name) {
                    check.value = !check.value;
                }
                if(e.target.name === 'none' && check.value){
                    this.updateState({allSelected:false})
                    check.value = false
                    if (check.name === e.target.name) check.value = true
                } else {
                    if (check.name === 'none') check.value = false
                }
            })
        } else if(mainKey === 'aiTools'){
            this.state.aiTools.forEach((check) => {
                if (check.name === e.target.name) {
                    check.value = !check.value;
                }
                if(e.target.name === 'no_ai_used' && e.target.checked && check.name !== 'no_ai_used') {
                    check.value = false
                } else if(e.target.name !== 'no_ai_used' && check.name === 'no_ai_used') {
                    check.value = false
                }
            })
        } else if(mainKey === 'premiereFeature'){
            this.state.premiereFeature.forEach((check) => {
                if (check.name === e.target.name) {
                    check.value = !check.value;
                }
            })
        } else if(mainKey === 'stockFootage'){
            this.state.stockFootage.forEach((check) => {
                if (check.name === e.target.name) {
                    check.value = !check.value;
                }
            })
        } else if(mainKey === 'fireflyModules'){
            this.state.fireflyModules.forEach((check) => {
                if (check.name === e.target.name) {
                    check.value = !check.value;
                }
            })
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    fireflyModules: {
                        ...this.state.userInfo.fireflyModules,
                        [e.target.name]: e.target.checked
                    }
                }
            })
        } else {
            this.state.realTimes3DTools.forEach((check) => {
                if (check.name === e.target.name) {
                    check.value = !check.value;
                }
            })
        }
    };
    handleTechnologyChange = (e, mainKey) => {
        const { name, checked } = e.target;
        if(name === 'None' && checked && mainKey === 'useOtherTechnologyHardware'){
            this.updateState({
                userInfo:{
                    ...this.state.userInfo,
                    [mainKey]:{
                        None: checked,
                        audioSoftware: false,
                        desktopLaptop: false,
                        gameEngine: false,
                        graphicsSoftware: false,
                        mobilePhoneTechnology: false,
                        soundMixingSoftware: false,
                        storageDevices: false,
                        vrArHeadset: false,
                    }
                }
            })
        } else {
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    [mainKey]: {
                        ...this.state.userInfo[mainKey],
                        [name]: checked,
                        None:false
                    }
                }
            })
        }
    };

    handleChange = (e, mainKey) => {
        const { name, value } = e.target;
        // this.setState({ userInfo:{ ...this.state.userInfo, [mainKey]: { ...this.state.userInfo[mainKey], [name]: value } } 
        // this.setState({ userInfo:{ ...this.state.userInfo, [mainKey]: value  } 
        // })
        if (mainKey === 'softwareUsedToEditNote' || mainKey === 'influencedCameraNote' || mainKey === 'fileMakerId' || mainKey === 'article' || mainKey === 'title' || mainKey === 'englishPhoneticProdununciation') {
            this.updateState({
                userInfo: { ...this.state.userInfo, [mainKey]: value }
            })
        } else if(name === 'category'){
            this.updateState({
                userInfo: { ...this.state.userInfo, [name]: value }
            })
        } else {
            this.updateState({
                // userInfo: { ...this.state.userInfo, [name]: value } 
                userInfo: { ...this.state.userInfo, [mainKey]: { ...this.state.userInfo[mainKey], [name]: value } }
            })
        }
    };

    submitThirdForm = (e) => {
        if (e) e.preventDefault();
        if (this.props.recordConflict) {
            this.setState({ showConflictModal: true });
            return;
        }
        var AllData = this.state.userdata;
        var UpdatedData = this.state.userInfo;
        let DATA = {
            projectId: AllData._id,
            // mediaId: UpdatedData.mediaId ? UpdatedData.mediaId : '',
            fileMakerId: UpdatedData.fileMakerId ? UpdatedData.fileMakerId : '',
            title: UpdatedData.title,
            pafType: UpdatedData.pafType,
            article: UpdatedData.article,
            category: UpdatedData.category,
            filmProjectType: UpdatedData.filmProjectType,
            englishPhoneticProdununciation: UpdatedData.englishPhoneticProdununciation,
            studentScreening: UpdatedData.studentScreening,
            freeCommunityScreening: UpdatedData.freeCommunityScreening,
            historyOfFilm: UpdatedData.historyOfFilm,
            adobeProductUse: UpdatedData.adobeProductUse,
            aiTools: UpdatedData.aiTools,
            fireflyModules: UpdatedData.fireflyModules,
            premiereFeature: UpdatedData.premiereFeature,
            stockFootage: UpdatedData.stockFootage,
            cameras: UpdatedData.cameras,
            cameraPurchaseOrRent: UpdatedData.cameraPurchaseOrRent,
            cameraAnamorphicOrSpecialLense: UpdatedData.cameraAnamorphicOrSpecialLense,
            useCameraLence: UpdatedData.useCameraLence,
            influencedCamera: UpdatedData.influencedCamera,
            softwareUsedToEdit: UpdatedData.softwareUsedToEdit,
            softwareUsedToEditNote: UpdatedData.softwareUsedToEditNote,
            influencedCameraNote: UpdatedData.influencedCameraNote,
            useAdobeProducts: UpdatedData.useAdobeProducts,
            useHardware: UpdatedData.useHardware,
            useOtherTechnologyHardware: UpdatedData.useOtherTechnologyHardware,
            realTimes3DTools: UpdatedData.realTimes3DTools,
            useOtherTechnologyHardware: UpdatedData.useOtherTechnologyHardware,
            useStockFootage: UpdatedData.useStockFootage,
            fundingPlatform: UpdatedData.fundingPlatform,
            sharingDistribution: UpdatedData.sharingDistribution,
            hybridDistribution: UpdatedData.hybridDistribution,
            useDropbox: UpdatedData.useDropbox,
            brieflyExplain: UpdatedData.brieflyExplain

        }
        this.setState({ loading: true })
        this.apiserve.sendevent("paf|project|updateThirdPage", DATA);
        // this.apiserve.success(' Project Saved Successful.')
        // this.props.history.push('/paf-projectlist');
    };
    
    previewRecord = (e) => {
        e.preventDefault()
        var AllData = this.state.userdata;
        var UpdatedData = this.state.userInfo;

        let ProjectInternal = {
            englishPhoneticProdununciation: UpdatedData.englishPhoneticProdununciation,
            credits: UpdatedData.credits,
            filmProjectType: UpdatedData.filmProjectType,
            category: UpdatedData.category,
            article: UpdatedData.article,
            title: UpdatedData.title,
            synopsis: UpdatedData.synopsis,
            countryOfOrigin: UpdatedData.countryOfOrigin,
            projectInfo: UpdatedData.projectInfo,
            digitalMedia: UpdatedData.digitalMedia,
            publicContact: UpdatedData.publicContact,
            postFestivalContact: UpdatedData.postFestivalContact,
            projectId: UpdatedData.projectId,
            images: UpdatedData.images,
            pafType: UpdatedData.pafType,
            // Contact Data
            fileMakerId: UpdatedData.fileMakerId ? UpdatedData.fileMakerId : '',
            pafType : UpdatedData.pafType,
            mainPublicityContacts : UpdatedData.mainPublicityContacts,
            mainContacts : UpdatedData.mainContacts,
            techContact : UpdatedData.techContact,
            // Project Internal
            mediaId: UpdatedData.mediaId ? UpdatedData.mediaId : '',
            studentScreening: UpdatedData.studentScreening,
            freeCommunityScreening: UpdatedData.freeCommunityScreening,
            historyOfFilm: UpdatedData.historyOfFilm,
            adobeProductUse: UpdatedData.adobeProductUse,
            aiTools: UpdatedData.aiTools,
            premiereFeature: UpdatedData.premiereFeature,
            stockFootage: UpdatedData.stockFootage,
            cameras: UpdatedData.cameras,
            cameraPurchaseOrRent: UpdatedData.cameraPurchaseOrRent,
            cameraAnamorphicOrSpecialLense: UpdatedData.cameraAnamorphicOrSpecialLense,
            useCameraLence: UpdatedData.useCameraLence,
            influencedCamera: UpdatedData.influencedCamera,
            softwareUsedToEdit: UpdatedData.softwareUsedToEdit,
            useAdobeProducts: UpdatedData.useAdobeProducts,
            useHardware: UpdatedData.useHardware,
            useOtherTechnologyHardware: UpdatedData.useOtherTechnologyHardware,
            realTimes3DTools: UpdatedData.realTimes3DTools,
            useStockFootage: UpdatedData.useStockFootage,
            fundingPlatform: UpdatedData.fundingPlatform,
            sharingDistribution: UpdatedData.sharingDistribution,
            hybridDistribution: UpdatedData.hybridDistribution,
            useDropbox: UpdatedData.useDropbox,
            brieflyExplain: UpdatedData.brieflyExplain

        }
        let previewRecordFilm = this.apiserve.encrypt(ProjectInternal)
        this.setState({loading:true})
        this.apiserve.sendevent("tempStorage|create", {tempData:previewRecordFilm}); 
    }

    handleCheckAllOrigins = (e) => {
        let allOrigins = ["none","premierePro", "productionsInPremierePro", "speechToTextInPremierePro", "afterEffects", "frameIo", "cameraToCloud", "audition", "photoshop", "illustrator", "adobeMediaEncoder", "substance3D", "other"];
        let newAdobeList = []
        this.state.adobeProductUse.forEach((check) => {
            if(check.name === 'none' && check.isChecked){
                newAdobeList.push({
                    id:check.id,
                    name: check.name,
                    label:check.label,
                    value: check.name === 'none' ? false : true
                })
            } else{
                newAdobeList.push({
                    id:check.id,
                    name: check.name,
                    label:check.label,
                    value: check.name === 'none' ? false : !this.state.allSelected
                })
            }
        })
        allOrigins.forEach(origin => {
            this.state.userInfo.adobeProductUse[origin] = origin === 'none' ? false : !this.state.allSelected
        });
        this.updateState({adobeProductUse:newAdobeList,allSelected:!this.state.allSelected})
    };
    handleCheckAllPremiereFeature = (e) => {
        let allFeature = [ "textBasedEditing", "productionsInPremierePro", "mediaIntelligenceSearchPanel", "generativeExtend", "enhanceSpeech", "captionTranslation", "colorManagement" ];
        let newAdobeList = []
        this.state.premiereFeature.forEach((check) => {
            newAdobeList.push({
                id:check.id,
                name: check.name,
                label:check.label,
                value: !this.state.allPremiereFeatureSelected
            })
        })
        allFeature.forEach(origin => {
            this.state.userInfo.premiereFeature[origin] = !this.state.allPremiereFeatureSelected
        });
        this.updateState({premiereFeature:newAdobeList,allPremiereFeatureSelected:!this.state.allPremiereFeatureSelected})
    };
    handleCheckAllAiTools = (e) => {
        let allAiTools = [ "no_ai_used", "ideation_concept", "pre_production", "post_production", "visual_effects_animation", "sound_design_music", "marketing_promotional", "other" ];
        let newAdobeList = []
        this.state.aiTools.forEach((check) => {
            if(check.name === 'no_ai_used' && check.isChecked){
                newAdobeList.push({
                    id:check.id,
                    name: check.name,
                    label:check.label,
                    value: check.name === 'no_ai_used' ? false : true
                })
            } else{
                newAdobeList.push({
                    id:check.id,
                    name: check.name,
                    label:check.label,
                    value: check.name === 'no_ai_used' ? false : !this.state.allAiToolsSelected
                })
            }
        })
        allAiTools.forEach(origin => {
            this.state.userInfo.aiTools[origin] = !this.state.allAiToolsSelected
        });
        this.updateState({aiTools:newAdobeList,allAiToolsSelected:!this.state.allAiToolsSelected})
    };
    handleCheckAllFireflyModules = (e) => {
        const allChecked = this.state.fireflyModules.every(m => m.value)
        const newModules = this.state.fireflyModules.map(m => ({ ...m, value: !allChecked }))
        this.updateState({
            fireflyModules: newModules,
            userInfo: {
                ...this.state.userInfo,
                fireflyModules: newModules.reduce((acc, m) => ({ ...acc, [m.name]: !allChecked }), {})
            }
        })
    };
    handleCheckAllStockFootage = (e) => {
        let allOrigins = ["adobeStock", "shitterstock", "pond5", "getty", "dissolve", "other"];
        allOrigins.forEach(origin => {
            this.state.userInfo.stockFootage[origin] = !this.state.allSelected1
        });
        let newAdobeList = []
        this.state.stockFootage.forEach((check) => {
            newAdobeList.push({
                id:check.id,
                name: check.name,
                label:check.label,
                value: !this.state.allSelected1
            })
        })
        this.updateState({stockFootage:newAdobeList,allSelected1:!this.state.allSelected1})
    };
    handleCheckAllRealTime3DTools = (e) => {
        let allOrigins = ["notUseRealTimes3D", "Unity", "Unreal", "AdobeAero", "InHouse", "other"];
        allOrigins.forEach(origin => {
            this.state.userInfo.realTimes3DTools[origin] = !this.state.allSelected2
        });
        let newAdobeList = []
        this.state.realTimes3DTools.forEach((check) => {
            newAdobeList.push({
                id:check.id,
                name: check.name,
                label:check.label,
                value: !this.state.allSelected2
            })
        })
        this.updateState({realTimes3DTools:newAdobeList,allSelected2:!this.state.allSelected2})
    };

    render() {
        const { userInfo, mediaId, fileMakerId } = this.state;
        return (
            <>
            {this.state.loading ?  <Loader /> : ''}
                <form className="ps_contact_form ps_internal_form">
                    <div className="d_flex">
                        <div className="tab_col create_left_col">
                            <div className="d_flex fpg_media_id d_flex_align_center mb_5">
                                <div className="field_row horizontal_field paf_view_page ">
                                    <ul className="data_list ">
                                        <li className="d_flex">
                                           <label style={{width:"50px"}}>Media ID: </label>  <span id="id_text" className="ml_10" > {mediaId}</span>
                                        </li>
                                    </ul>
                                    {/* <TextField type="text" name="fileMakerId" id="fileMakerId" label="Media ID:" value={userInfo?.fileMakerId} onChange={this.handleChange} /> */}
                                </div>
                                <div className="field_row horizontal_field ml_10 ">
                                    <TextField type="text" name="fileMakerId" id="fileMakerId" label="Filemaker ID:" value={userInfo?.fileMakerId} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text_center mb_25"><h2>Internal Info</h2></div>
                    <div className="project_section">
                        <div className="paf_screening_info border_btm_1 pb_25 mb_25">
                            <div className="d_flex d_flex_justify_end w_100 info_first_row">
                                <div className="field_row horizontal_field ">
                                </div>
                                <div className="field_row horizontal_field ">
                                    <Dropdown label="PAF Type " value={userInfo?.pafType} disable={true} options={this.state.AllDropData.pafType} DefaultOption={'Select From Below'} />
                                </div>
                                <div className="field_row horizontal_field ">
                                    <DropdownMaster label="Film/Project Category" value={userInfo?.category} options={this.state.AllDropData.filmCategoryData} name='category' onChange={this.handleChange} defaultValue={'Select From Below'} disable={userInfo?.pafType === PAF_TYPES.NEW_FRONTIER}/>
                                </div>
                            </div>
                            <div className="d_flex w_100 info_first_row d_flex_justify_end">
                                <div className="field_row horizontal_field">
                                    <TextField value={userInfo?.article} label="Article" name='article' id='article' onChange={this.handleChange} />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField value={userInfo?.title} label="Title" name='title' id='title' onChange={this.handleChange} />
                                </div>
                                <div className="field_row horizontal_field">
                                    <TextField value={userInfo?.englishPhoneticProdununciation} label="English Phonentic Pronunciation" name='englishPhoneticProdununciation' id='englishPhoneticProdununciation' onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                       {userInfo?.pafType !== PAF_TYPES.NEW_FRONTIER && <div className="paf_screening_info border_btm_1 mb_25 pb_20">
                            <h2 className="mb_10">Colorado Student and Community Audiences</h2>
                            <h3 className="mb_10">Community Engagement Program</h3>
                            <p className='top_heading'>Interact with engaged local audiences including communities who may identify with your subject matter or young film students who are excited to experience independent cinema.</p>
                            <h3 className="mb_10 ps_contactsubtitle">Free Community Screenings</h3>
                            <h3 className="mb_10 ps_contactsubtitle">Community screenings help make independent film more accessible, inclusive, and equitable, bringing free Festival films to local audiences. The director or another team member must participate in a Q&A for any scheduled community screenings.</h3>
                            {this.getTextAreaWithSelect(
                               "Are there any specific target audiences that may especially connect with your film/project? For example, particular cultural communities, language speakers, age groups, etc? If you are connected with specific organizations or community groups, especially those with a Colorado presence, please include these as well. Put N/A if not applicable.",
                                "", "freeCommunityScreening", 'flag', 'note', userInfo?.freeCommunityScreening?.flag, userInfo?.freeCommunityScreening?.note
                                )}
                            <h3 className="mb_10 ps_contactsubtitle">University of Colorado Boulder Student Screenings </h3>
                            <h3 className='mb_10 ps_contactsubtitle'>Screenings held for University of Colorado Boulder students provide a chance for these students to experience a new perspective, gain direct exposure to the art of film, and interact with the creative team behind the story. If your film is selected, the director or another team member must participate in a Q&A for any scheduled student screenings.</h3>
                            <h3 className="mb_10 ps_contactsubtitle">Sensitive Content Consideration</h3>
                            {this.getTextAreaWithSelect(
                               'Does your film contain content that might be considered sensitive? Please elaborate on the type of content your film has, e.g. strong language, substance abuse, violence (including guns), suicide, sex scenes, and/or nudity.',"",
                                "studentScreening", 'flag', 'note', userInfo?.studentScreening?.flag, userInfo?.studentScreening?.note
                            )}

                        </div>}
                        <div className="paf_screening_info border_btm_1 mb_10 pb_20">
                            <h2 className="mb_10">History of Film/Project</h2>
                            {this.getTextAreaWithSelect(
                                "Has your film/project screened at other festivals? Please name the festival, and if applicable, the name of any award(s) won.",
                                "", "historyOfFilm", 'awardWinFlag', 'awardWinNote', userInfo?.historyOfFilm?.awardWinFlag, userInfo?.historyOfFilm?.awardWinNote, true
                            )}

                            {this.getTextAreaWithSelect(
                                "Does your film have U.S. or international distribution? If so, please list companies and territories. Was it financed by any of these distributors, or was it acquired upon completion?",
                                "", "historyOfFilm", 'acquiredForUSFlag', 'acquiredForUSNote', userInfo?.historyOfFilm?.acquiredForUSFlag, userInfo?.historyOfFilm?.acquiredForUSNote, true
                            )}

                            {this.getTextAreaWithSelect(
                                "Was your film/project or its artist(s) supported by a Sundance Institute lab, grant, or other program prior to its selection for the Festival? If yes, please explain.",
                                "", "historyOfFilm", 'instituteLabGrantFlag', 'instituteLabGrantNote', userInfo?.historyOfFilm?.instituteLabGrantFlag, userInfo?.historyOfFilm?.instituteLabGrantNote, true
                            )}

                            {this.getTextAreaWithSelect("Was your film/project made in Colorado? Does it have any Colorado affiliated filmmakers or cast?",
                                "", "historyOfFilm", 'isUtahFlag', 'isUtahNote', userInfo?.historyOfFilm?.isUtahFlag, userInfo?.historyOfFilm?.isUtahNote, true
                            )}
                        </div>

                        <div className="paf_screening_question pb_20">
                            <h2 className="mb_25 pb_15">Production Information</h2>
                            {this.getCameraDetails('What camera did you use to shoot your project(make/model)?','(Can enter up to 2)')}
                            {this.getSingleDropdown('Did you purchase or rent this camera?', this.state.options['cameraPurchaseOrRent'], 'cameraPurchaseOrRent')}
                            {this.getSingleDropdown('Did you use Anamorphic or Spherical lenses?', this.state.options['cameraAnamorphicOrSpecialLense'], 'cameraAnamorphicOrSpecialLense')}
                            {this.getLenseDetails('Which Lenses did you use to shoot your project?','(Can enter up to 2)')}
                            {this.getSingleDropdown('What influenced the camera selection?', this.state.options['influencedCamera'], 'influencedCamera')}
                            {userInfo && (userInfo.influencedCamera === 'Format' || userInfo.influencedCamera === 'Features') && <div className="field_row horizontal_field"> <TextField type='text' label={userInfo.influencedCamera === 'Format' ? "Which Format?" : "Which Features?"} name='influencedCameraNote' id='influencedCameraNote' value={userInfo && userInfo?.influencedCameraNote} onChange={(e) => this.handleChange(e, 'influencedCameraNote')} /> </div>}
                            {this.getSingleDropdown('Which software was used to edit your film?', this.state.options['softwareUsedToEdit'], 'softwareUsedToEdit')}
                            {userInfo && userInfo.softwareUsedToEdit === 'Other' &&
                                <div className="field_row horizontal_field"> <TextField type='text' label="Other" name='softwareUsedToEditNote' id='softwareUsedToEditNote' value={userInfo && userInfo?.softwareUsedToEditNote} onChange={(e) => this.handleChange(e, 'softwareUsedToEditNote')} /> </div>
                            }

                            {this.getSingleDropdown('Did you use Adobe Creative Cloud software for any of the pre-production, production, post-production or marketing of your film?', this.state.options['useAdobeProducts'], 'useAdobeProducts')}
                            <div>
                                <div className="field_row">
                                    <label>If any Adobe solutions were used on your film, which ones?</label>
                                    <h6 className="ps_checkall mb_15" onClick={(e) => this.handleCheckAllOrigins(e)}>(Check all that apply.)</h6> 
                                </div>
                                {console.log(this.state.adobeProductUse,"this.state.adobeProductUse")}
                                <div className="d_flex ps_check_column">
                                    {
                                        this.state.adobeProductUse.length > 0 && this.state.adobeProductUse.map((product, index) => {
                                            return (
                                                <CheckBox checked={product.value} name={product.name} label={product.label} type="checkbox" id={product.id} onChange={(e) => this.handleProductChange(e, 'adobeProductUse')} />
                                            )
                                        })
                                    }
                                    {userInfo && userInfo.adobeProductUse.other && <div className="field_row horizontal_field"> <TextField name='otherDesc' value={userInfo && userInfo.adobeProductUse.otherDesc} label="" onChange={(e) => this.handleChange(e, 'adobeProductUse')} /> </div>}
                                </div>
                            </div>
                            <div>
                                <div className="field_row">
                                    <label>If you used Firefly, did you use any of the following modules?</label>
                                    <h6 className="ps_checkall mb_15" onClick={(e) => this.handleCheckAllFireflyModules(e)}>(Select all that apply)</h6>
                                </div>
                                <div className="d_flex ps_check_column">
                                    {
                                        this.state.fireflyModules.length > 0 && this.state.fireflyModules.map((module, index) => {
                                            return (
                                                <CheckBox checked={module.value} name={module.name} label={module.label} type="checkbox" id={'f'+module.id} onChange={(e) => this.handleProductChange(e, 'fireflyModules')} />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div>
                                <div className="field_row">
                                    <label>If you used Premiere, did you use any of the following features on your film?</label>
                                    <h6 className="ps_checkall mb_15" onClick={(e) => this.handleCheckAllPremiereFeature(e)}>(Check all that apply.)</h6> 
                                </div>
                                <div className="d_flex ps_check_column">
                                    {
                                        this.state.premiereFeature.length > 0 && this.state.premiereFeature.map((product, index) => {
                                            return (
                                                <CheckBox checked={product.value} name={product.name} label={product.label} type="checkbox" id={'p'+product.id} onChange={(e) => this.handleProductChange(e, 'premiereFeature')} />
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            {this.getSingleDropdown('Did you use any stock footage in your film?', ['Yes', 'No'], 'useStockFootage')}
                            <div>
                                <div className="field_row">
                                    <label>If yes, which of the following sources did you use for your stock footage?</label>
                                    <h6 className="ps_checkall mb_15" onClick={(e) => this.handleCheckAllStockFootage(e)}>(Check all that apply.)</h6>
                                </div>
                                <div className="d_flex ps_check_column">
                                    {

                                        this.state.stockFootage.length > 0 && this.state.stockFootage.map((footage, index) => {
                                            return (
                                                <CheckBox checked={footage.value} name={footage.name} label={footage.label} type="checkbox" id={footage.id} onChange={(e) => this.handleProductChange(e, 'stockFootage')} />
                                            )
                                        })
                                    }
                                    {userInfo && userInfo.stockFootage.other && <div className="field_row horizontal_field"> <TextField name='otherDesc' value={userInfo && userInfo.stockFootage.otherDesc} label="" onChange={(e) => this.handleChange(e, 'stockFootage')} /> </div>}
                                </div>
                            </div>

                            {this.getSingleDropdown('What primary computer hardware did you use to complete your film?', this.state.options['useHardware'], 'useHardware')}
                            {/* {this.getSingleDropdown('Did you use 3D real-time tools/engines in the making of this experience?', this.state.options['realTimes3DTools'], 'realTimes3DTools')} */}

                            <div>
                                <div className="field_row">
                                    <label>Did you use 3D real-time tools/engines in the making of this experience?</label>
                                    <h6 className="ps_checkall mb_15" onClick={(e) => this.handleCheckAllRealTime3DTools(e)}>(Check all that apply.)</h6>
                                </div>
                                <div className="d_flex ps_check_column">
                                    {

                                        this.state.realTimes3DTools.length > 0 && this.state.realTimes3DTools.map((tool, index) => {
                                            return (
                                                <CheckBox checked={userInfo && userInfo.realTimes3DTools[tool.name] ? true : false} name={tool.name} label={tool.label} type="checkbox" id={tool.id} onChange={(e)=> this.handleProductChange(e, 'realTimes3DTools')} />
                                            )
                                        })
                                    }
                                    {userInfo && userInfo.realTimes3DTools.other && <div className="field_row horizontal_field"> <TextField name='otherDesc' value={userInfo && userInfo.realTimes3DTools.otherDesc} label="" onChange={(e) => this.handleChange(e, 'realTimes3DTools')} /> </div>}
                                </div>
                            </div>

                            {/* {this.getSingleDropdown('Which creative funding platform did you use to produce your film??', this.state.options['fundingPlatform'], 'fundingPlatform')}
                            {this.getSingleDropdown('Are you open to sharing distribution data on your Project?', ['Yes', 'No'], 'sharingDistribution')}
                            {this.getSingleDropdown('Do you have interest in hybrid distribution?', ['Yes', 'No'], 'hybridDistribution')} */}
                            {this.getSingleDropdown('Did you use Dropbox (or Dropbox Replay, Sign, or DocSend) during the planning, production, or distribution of your film/project?', ['Yes', 'No'], 'useDropbox')}

                            {userInfo?.useDropbox === 'Yes' && <div className="field_row">
                                <div className="ps_prod_que_label field_row">
                                    <label>If yes: briefly note which product(s) were used and how</label>
                                </div>
                                <Textarea height="180px" width='100%' name='brieflyExplain' value={userInfo?.brieflyExplain} onChange={(e) => this.handleChangeSingleDrop(e, 'brieflyExplain')} />
                            </div>}
                        </div>

                        <div className="text_center field_row w_100 buttons_outer">
                            <button className="uppercase" type='button' onClick={() => this.cancelFn()}>CANCEL</button>
                            <button className="uppercase prev_btn" type='button' onClick={(e) => this.previewRecord(e)}>PREviEW</button>
                            <button disabled={this.state.loading || !this.state.isProjectInternalEdited} className={`uppercase ${ !(this.state.loading || !this.state.isProjectInternalEdited) ? 'active' : '' }`} type='button' onClick={(e) => this.state.loading ? '' : this.submitThirdForm(e)} >SAVE </button>
                        </div>
                        <div className='mt_15'>
                            <div className="field_row">
                                <label>Did you use any artificial intelligence (AI) tools or workflows in the creation of your film?</label>
                                <h6 className="ps_checkall mb_15" onClick={(e) => this.handleCheckAllAiTools(e)}>(Select all that apply)</h6>
                            </div>
                            <div className="d_flex" style={{maxWidth:'750px'}}>
                                {
                                    this.state.aiTools.length > 0 && this.state.aiTools.map((product, index) => {
                                        const hasSubField = ['ideation_concept', 'pre_production', 'production', 'post_production', 'visual_effects_animation', 'sound_design_music', 'marketing_promotional'].includes(product.name)
                                        return (
                                            <React.Fragment key={product.id} >
                                                <div className='' style={{width:'50%'}}>
                                                    <CheckBox checked={product.value} name={product.name} label={product.label} type="checkbox" id={'a'+product.id} onChange={(e) => this.handleProductChange(e, 'aiTools')} />
                                                    {hasSubField && product.value && (
                                                        <div className="field_row horizontal_field" style={{paddingLeft:'20px'}}>
                                                            <TextField name={`${product.name}_tool`} value={userInfo && userInfo.aiTools && userInfo.aiTools[`${product.name}_tool`] ? userInfo.aiTools[`${product.name}_tool`] : ''} placeholder="What AI tool did you use?" onChange={(e) => this.handleChange(e, 'aiTools')} />
                                                        </div>
                                                    )}
                                                    {userInfo && userInfo.aiTools.other && product.name === 'other' && (
                                                        <div className="field_row horizontal_field" style={{paddingLeft:'20px'}}>
                                                            <TextField name='otherDesc' value={userInfo && userInfo.aiTools.otherDesc} label="" onChange={(e) => this.handleChange(e, 'aiTools')} />
                                                        </div>
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </form>



            <ConflictSaveModal
                isVisible={this.state.showConflictModal}
                conflict={this.props.recordConflict}
                onClose={() => this.setState({ showConflictModal: false })}
            />
            </>
        )
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectInternal)
